import { Component, OnInit,Input} from '@angular/core';

@Component({
    selector: 'app-f-statements',
    templateUrl: './f-statements.component.html',
    styleUrls: ['./f-statements.component.scss'],
    standalone: false
})
export class FStatementsComponent implements OnInit {

  constructor() { }
  @Input() chartKey: string = '';
  ngOnInit(): void {
   //console.log("Ticker on statement page is",this.chartKey)
  }
  selectedTab1: number = 0;
  selectTab1(index: number): void {
    this.selectedTab1 = index;
  }
}
